export const CODE_QUANTITY_NOT_AVAILABLE = "itemQuantityNotAvailable";
export const CODE_QUANTITY_LIMIT_REACHED = "itemMaxQuantityLimitReached";

export const TRY_AGAIN_LATER =
  "Desculpe, identificamos uma instabilidade no sistema e não foi possível concluir esta ação.<br/>Por favor, tente novamente mais tarde.";
